import { matchPath } from 'react-router-dom';

/* All system route */
import user_routes from '../User/routes';
import insurance_routes from '../Insurance/routes';
import request_routes from '../Request-Types/routes';
import project_routes from '../Projects/routes';
import clients_routes from '../Subcontractors/routes';
import room_routes from '../Rooms/routes';
import model_routes from '../Model/routes';
import work_routes from '../Work-Order-Type/routes';
import work_order_routes from '../Work-Orders/routes';
import lots_routes from '../Lots/routes';
import rs_routes from '../Request-Services/routes';
import region_market from '../Region-Market/routes';
import auth_routes from '../Auth/routes';
import builder_routes from 'Builders/routes';
import items_routes from 'Items/routes';
import setting_routes from 'Setting/routes';
import error_page_routers from '../errorPage/routers';
import cost_code_routers from '../CostCodes/routers';
import home_owners_routes from '../HomeOwners/routes';
import manage_roles from '../Manage-Roles/routes';
import punch_list_routes from '../Punch-List/routes';
import izenda_routes from '../izenda/routers';
import trade_routes from '../Trades/routes';
import search_routes from '../Search/routes';
import ml_routes from '../MediaLibrary/routes';
import dashboard_routes from '../Dashboard/routes';
import purchase_order_routers from '../Purchase-Orders/routers';

export const checkRoute = (routes, pathname) => {
  let match = null;

  for (let i = 0; i < routes.length; i++) {
    match = matchPath(pathname, {
      path: routes[i].path,
      exact: true,
      sensitive: routes[i].component.sensitive
    });

    if (match) {
      return routes[i];
    }
  }

  return null;
};

export const checkAllSystemRoute = (pathname) => {
  const routes = [].concat(
    user_routes,
    insurance_routes,
    request_routes,
    project_routes,
    clients_routes,
    room_routes,
    model_routes,
    work_routes,
    work_order_routes,
    lots_routes,
    rs_routes,
    region_market,
    auth_routes,
    builder_routes,
    items_routes,
    setting_routes,
    error_page_routers,
    cost_code_routers,
    home_owners_routes,
    manage_roles,
    punch_list_routes,
    izenda_routes,
    trade_routes,
    search_routes,
    purchase_order_routers,
    ml_routes,
    dashboard_routes
  );

  let match = null;

  for (let i = 0; i < routes.length; i++) {
    match = matchPath(pathname, {
      path: routes[i].path,
      exact: true,
      sensitive: routes[i].component.sensitive
    });
    if (match) {
      return routes[i];
    }
  }
  return null;
};




// WEBPACK FOOTER //
// ./src/helper/check-route-helper.js